import React, { useState, useCallback, useMemo } from "react";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../../components/Icon";
import ModalDocument from "../../../../components/ModalViewDocument";
import {
  downloadDocument,
  ConfirmDocument,
  RefuseDocument,
  deleteDocument,
} from "../../../../services/documents.service";
import { showSuccess, showInfo, showError } from "../../../../services/toast.service";

const Control = ({ className, document: documentData, onDocumentChange }) => {
  const [visibleModalProduct, setVisibleModalProduct] = useState(false);

  // --- START: Missing handler functions (now included) ---

  const handleDownload = useCallback(async () => {
    if (!documentData) {
      showInfo("Aucun document à télécharger.");
      return;
    }
    const success = await downloadDocument(documentData);
    if (success) {
      showSuccess("Document téléchargé avec succès !");
    } else {
      showError("Échec du téléchargement du document.");
    }
  }, [documentData]);

  const handleConfirm = useCallback(async () => {
    if (!documentData) return;
    const success = await ConfirmDocument(documentData);
    if (success) {
      showSuccess("Document confirmé avec succès !");
      if (onDocumentChange) onDocumentChange();
    } else {
      showError("Échec de la confirmation du document.");
    }
  }, [documentData, onDocumentChange]);

  const handleRefuse = useCallback(async () => {
    if (!documentData) return;
    const success = await RefuseDocument(documentData);
    if (success) {
      showInfo("Document refusé.");
      if (onDocumentChange) onDocumentChange();
    } else {
      showError("Échec du refus du document.");
    }
  }, [documentData, onDocumentChange]);

  const handleDelete = useCallback(async () => {
    if (!documentData) return;
    const success = await deleteDocument(documentData);
    if (success) {
      showSuccess("Document supprimé avec succès !");
      if (onDocumentChange) onDocumentChange();
    } else {
      showError("Échec de la suppression du document.");
    }
  }, [documentData, onDocumentChange]);

  const handleExpand = useCallback(() => {
    setVisibleModalProduct(true);
  }, []);

  // --- END: Missing handler functions (now included) ---


  const actions = useMemo(() => {
    const currentStatut = documentData?.statut;

    const commonActions = [
      {
        icon: "download",
        action: handleDownload, // This was undefined
        title: "Télécharger le document",
      },
      {
        icon: "trash",
        action: handleDelete,
        title: "Supprimer le document",
      },
      {
        icon: "expand",
        action: handleExpand, // This was undefined
        title: "Voir l'aperçu",
      },
    ];

    if (currentStatut === 'pending' || currentStatut === 'submitted') {
      return [
        {
          icon: "check",
          action: handleConfirm, // This was undefined
          title: "Confirmer le document",
        },
        {
          icon: "close",
          action: handleRefuse, // This was undefined
          title: "Refuser le document",
        },
        ...commonActions,
      ];
    }
    return commonActions;
  }, [documentData, handleDownload, handleDelete, handleExpand, handleConfirm, handleRefuse]); // All dependencies correctly listed

  return (
    <>
      <div className={cn(styles.control, className)}>
        {actions.map((x, index) => (
          <button
            className={styles.button}
            key={index}
            onClick={x.action}
            title={x.title || ''}
          >
            <Icon name={x.icon} size="20" />
          </button>
        ))}
      </div>
      <ModalDocument
        visible={visibleModalProduct}
        onClose={() => setVisibleModalProduct(false)}
        documentData={documentData}
        isProspect={false}
      />
    </>
  );
};

export default Control;